export const RequiredStar = () =>
    <span
        style={{
            color: 'red',
            fontFamily: 'Inter, sans-serif'
        }}
    >*</span>